var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.unlimited)?_c('TiledSelect',{attrs:{"value":_vm.unlimitedOptionName,"selected":""}},[_vm._v(_vm._s(_vm.unlimitedTextContent))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/tiled-select/tiled-select-group.vue